import { Asset } from 'nftx.js';
import SelectInventoryForm, {
  SelectInventoryFormFields,
} from '@/components/forms/CreatePositionForms/SelectInventoryForm';
import { Dispatch, ReactNode, useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { CreateInventoryPositionDetails } from '../../types';
import { QueryStatus } from '@tanstack/react-query';

export interface CreateInventoryPositionProps {
  assetName: string;
  assets: Asset[];
  withinModal?: boolean;
  is1155?: boolean;
  dispatch: Dispatch<Partial<CreateInventoryPositionDetails>>;
  items: CreateInventoryPositionDetails['items'];
  onSubmit: () => void;
  Sidebar: ReactNode;
  status: QueryStatus;
}

export const SelectInventory = ({
  assetName,
  assets,
  withinModal = false,
  is1155,
  onSubmit,
  dispatch,
  items: initialItems = [],
  Sidebar,
  status,
}: CreateInventoryPositionProps) => {
  const {
    control,
    formState: { errors },
    setValue,
    handleSubmit,
  } = useForm<SelectInventoryFormFields>({
    defaultValues: {
      items: initialItems,
    },
  });

  const { items } = useWatch({ control });

  useEffect(() => {
    if (items) {
      dispatch({ items: items as SelectInventoryFormFields['items'] });
    }
  }, [dispatch, items]);

  const onFormSubmit = handleSubmit((values) => {
    dispatch(values);
    onSubmit();
  });

  return (
    <form
      className="grid grid-cols-1 md:grid-cols-3 gap-8 relative"
      onSubmit={onFormSubmit}
    >
      <section className="md:col-span-2">
        <SelectInventoryForm
          status={status}
          collectionName={assetName}
          control={control}
          errors={errors}
          setValue={setValue}
          is1155={!!is1155}
          userAssets={assets}
          withinModal={withinModal}
        />
      </section>
      {Sidebar}
    </form>
  );
};

export default SelectInventory;
